import React, { useState, useEffect, useContext } from 'react';
import CabeceraHistorialOrden from '../components/ProductosServicios/CabeceraHistorialOrden';
import IncluirNoDispobibles from '../components/ProductosServicios/IncluirNoDispobibles';
import RangoPrecios from '../components/ProductosServicios/RangoPrecios';
import PaginatedItems from '../components/PaginacionProductos/PaginacionItems';
import { CategoriasContext } from '../context/CategoriasContext';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDolar } from '../context/ValorDolarContext';
import clienteAxios from '../helpers/axios.helper';
import OrdenarProductos from '../components/ProductosServicios/OrdenarProductos';

function ProductosServicios() {
  const { valorDolar } = useDolar(); // Extraemos funciones del contexto
  const navigate = useNavigate();
  const location = useLocation();
  // const searchParams = new URLSearchParams(location.search);
  const idMarca = location.state?.id;
  const marcas = location.state?.marcas;
  const deCategorias = location.state?.deCategorias;
  const deCarrito = location.state?.deCarrito;

  const idServicio = location.state?.idS;
  const categoriaServicios = location.state?.categoriaServicios;
  const [search, setSearch] = useState();
  const { marca } = useParams();
  const { categoriasSeleccionadas, tercerasCategorias, actualizarCategorias, subcategorias, actualizarSubCategorias, actualizarTercerasCategorias } = useContext(CategoriasContext);
  const [laCategoriaPrincipalSeleccionada, setLaCategoriaPrincipalSeleccionada] = useState(categoriasSeleccionadas[0])
  const [listadoMarcas, setListadoMarcas] = useState([]);
  const [listadoServicios, setListadoServicios] = useState([]);
  const [mostrarTodos, setMostrarTodos] = useState(true)
  const [sCategorias, setSCategorias] = useState([]);
  const [tCategorias, setTCategorias] = useState([]);
  const [marcaSeleccionada, setMarcaSeleccionada] = useState({});
  const [servicioSeleccionado, setServicioSeleccionado] = useState(categoriaServicios?.find((s) => s.id === idServicio) || {});
  const [selectedOrden, setSelectedOrden] = useState({ id: null, option: null });
  const [mostrarNoDisponible, setMostrarNoDisponible] = useState(true);
  const [productosFiltrados, setProductosFiltrados] = useState([]);
  const [serviciosFiltrados, setServiciosFiltrados] = useState([]);
  const [filtros, setFiltros] = useState({
    base: true,
    orden: 0,
    min: "-",
    max: "-",
    mostrarNoDisponible,
    categoria: "-",
    subCategoria: "-",
    terceraCategoria: "-",
    marcaSelec: "-",
    valorDolar: valorDolar,
    modo: '-',
    palabraBuscar: '-'
  });

  const [paginaActual, setPaginaActual] = useState(1);
  const [itemsPorPagina, setItemsPorPagina] = useState(15);  // Puedes ajustar este valor según lo que quieras mostrar por página
  const [totalProductosFiltrados, setTotalProductosFiltrados] = useState(0);  // Puedes ajustar este valor según lo que quieras mostrar por página
  const [totalServiciosFiltrados, setTotalServiciosFiltrados] = useState(0);  // Puedes ajustar este valor según lo que quieras mostrar por página

  const [navegacionDesde, setNavegacionDesde] = useState("categorias");

  const handleCategoria = (c, n) => {
    actualizarCategorias(prevCategorias => [...prevCategorias, c]);
    if (n === 1) {
      setFiltros(prevFiltros => ({
        ...prevFiltros,
        base: false,
        subCategoria: c.id,
        terceraCategoria: "-",
        modo: '-'
      }));
      actualizarSubCategorias(c);
      actualizarTercerasCategorias(c.terceraCategoria);
      setTCategorias(c.terceraCategoria || []);
    } else if (n === 2) {
      setFiltros(prevFiltros => ({
        ...prevFiltros,
        base: false,
        terceraCategoria: c.id,
        modo: '-'
      }));
    }
  };

  const handleCambioMarca = (m) => {
    setMarcaSeleccionada(m);
    setFiltros(prevFiltros => ({
      ...prevFiltros,
      base: false,
      marcaSelec: m.id,
      modo: '-',
      valorDolar: valorDolar,
    }));
    navigate(`/productos/${m.nombre}`, { replace: true, state: { id: m.id, marcas: listadoMarcas } });
  };

  const handleServicio = (s) => {
    setServicioSeleccionado(s);
    const tituloModificado = s.titulo.replace(/ /g, '_');
    navigate(`/post-venta/${tituloModificado}`, { replace: true, state: { idS: s.id, categoriaServicios: listadoServicios } });
  };
  
  
  const cambiarPagina = (event) => {
    const nuevaPagina = event.selected + 1; // ReactPaginate usa índice basado en 0, pero las páginas normalmente empiezan desde 1.
    setPaginaActual(nuevaPagina); // Actualiza el estado con la nueva página
  };
  const handleMostrarTodos = () => {
    setFiltros((prevFiltros) => ({
      ...prevFiltros,
      base: false,
      min: "-",
      max: "-",
      donde: "switchdefault",
      categoria: "-",
      subCategoria: "-",
      terceraCategoria: "-",
      palabraBuscar: '-',
      marcaSelec: "-",
      modo: 'todos',
      orden: selectedOrden.id ?? 0,
      mostrarNoDisponible,
      valorDolar: valorDolar,
    }));
    setSearch(false);
    setMostrarTodos(true);
    setNavegacionDesde("todos");
  }
  function getHeader() {
    if (search) {
      return (
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center w-full">
          <h1 className="text-Negro font-bold p-2 text-center md:text-left">
            Resultados de búsqueda para:
            <label className="text-Verde font-bold text-xl">{` "${search}" `}</label>
          </h1>
          <div className="p-2">
            <OrdenarProductos
              selectedOrden={selectedOrden}
              setSelectedOrden={setSelectedOrden}
            />
          </div>
        </div>
      );
    }
  
    if (mostrarTodos) {
      return (
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center w-full">
          <h1 className="text-Negro font-bold p-2 text-center md:text-left">
            <label className="text-Verde font-bold text-xl">Todos los Productos</label>
          </h1>
          <div className="p-2">
            <OrdenarProductos
              selectedOrden={selectedOrden}
              setSelectedOrden={setSelectedOrden}
              setFiltros={setFiltros}
              donde="mostratodo"
            />
          </div>
        </div>
      );
    }
  
    if (marcaSeleccionada.id) {
      return (
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center w-full">
          <h1 className="text-Negro font-bold p-2 text-center md:text-left">
            Productos de la marca:
            <label className="text-Verde font-bold text-xl">{` ${marcaSeleccionada.nombre}`}</label>
          </h1>
          <div className="p-2">
            <OrdenarProductos
              selectedOrden={selectedOrden}
              setSelectedOrden={setSelectedOrden}
            />
          </div>
        </div>
      );
    }
  
    if (servicioSeleccionado.id) {
      // Caso especial para servicios: No se muestra "Ordenar por"
      return (
        <h1 className="text-Negro font-bold p-2 text-center md:text-left">
          Servicio:
          <label className="text-Verde font-bold text-xl">{` ${servicioSeleccionado.titulo}`}</label>
        </h1>
      );
    }
  
    // Caso general con categorías seleccionadas
    return (
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center w-full">
        <div className="flex-1 p-2 text-center md:text-left">
          <CabeceraHistorialOrden
            selectedOrden={selectedOrden}
            setSelectedOrden={setSelectedOrden}
            categoriaSeleccionada={categoriasSeleccionadas}
          />
        </div>
        <div className="p-2">
          <OrdenarProductos
            selectedOrden={selectedOrden}
            setSelectedOrden={setSelectedOrden}
          />
        </div>
      </div>
    );
  }
  
  
  
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    setSearch(searchParams.get('search') || '');  // Esto actualizará 
   
  }, [location.search])


  useEffect(() => {
    const fetchFiltrados = async () => {
      try {
        const response = await clienteAxios.post(
          `/productos/filtrados?page=${paginaActual}&itemsPerPage=${itemsPorPagina}`,
          filtros
        );
        setProductosFiltrados(response.data.productos);
        setTotalProductosFiltrados(response.data.totalProductos);
      } catch (error) {
        console.error("Error fetching filtered products:", error);
      }
    };
    fetchFiltrados();
  }, [filtros, paginaActual, itemsPorPagina]);
  
  useEffect(() => {
    if (servicioSeleccionado) {
      const fetchServicios = async () => {
        try {
          const responses = await clienteAxios.post(
            `/servicios/porCategoriaPaginados/${servicioSeleccionado.id}?pagina=${paginaActual}&limite=10`
          );
          setServiciosFiltrados(responses.data.servicios);
          setTotalServiciosFiltrados(responses.data.total);
        } catch (error) {
          console.error('Error al cargar servicios:', error);
        }
      };
      fetchServicios(servicioSeleccionado)
    }
  }, [servicioSeleccionado, paginaActual, selectedOrden, mostrarNoDisponible]);

  useEffect(() => {
    if (deCarrito) {
      handleMostrarTodos()
    }
  }, [])
  useEffect(() => {
    if (search) {
      setFiltros({
        base: false,
        donde: "switchSearch",
        min: "-",
        max: "-",
        categoria: "-",
        subCategoria: "-",
        terceraCategoria: "-",
        marcaSelec: "-",
        valorDolar: valorDolar,
        modo: 'search',
        orden: selectedOrden.id ?? 0,
        mostrarNoDisponible,
        palabraBuscar: search,
      });
      setSCategorias([]);
      setTCategorias([]);
      setMarcaSeleccionada({});
      setServicioSeleccionado({});
      setListadoMarcas([]);
      setMostrarTodos(false);
      setNavegacionDesde("busqueda");
    }
  }, [search, selectedOrden, mostrarNoDisponible])
  useEffect(() => {
    if (idMarca) {
      const marcaInicial = marcas?.find((m) => m.id === idMarca) || {};
      setFiltros((prevFiltros) => ({
        ...prevFiltros,
        base: false,
        donde: "switchMarca",
        categoria: "-",
        subCategoria: "-",
        terceraCategoria: "-",
        marcaSelec: idMarca,
        modo: '-',
        orden: selectedOrden.id ?? 0,
        mostrarNoDisponible,
        valorDolar: valorDolar,
        palabraBuscar: '-',
      }));
      setMarcaSeleccionada(marcaInicial);
      setListadoMarcas(marcas);
      setMostrarTodos(false);
      setNavegacionDesde("marcas");
    }
  }, [idMarca, marcas, selectedOrden, mostrarNoDisponible])

  useEffect(() => {
    if (idServicio) {
      setFiltros((prevFiltros) => ({
        ...prevFiltros,
        base: false,
        donde: "switchServicio",
        categoria: "-",
        subCategoria: "-",
        terceraCategoria: "-",
        marcaSelec: "-",
        modo: '-',
        orden: selectedOrden.id ?? 0,
        mostrarNoDisponible,
        valorDolar: valorDolar,
      }));
      setListadoServicios(categoriaServicios);
      setMostrarTodos(false);
      setNavegacionDesde("servicios");
    }
  }, [idServicio])
  useEffect(() => {
    if (deCategorias) {
      setFiltros((prevFiltros) => ({
        ...prevFiltros,
        base: false,
        donde: "switchcategoria",
        categoria: categoriasSeleccionadas[0]?.id || "-",
        subCategoria: categoriasSeleccionadas[1]?.id || "-",
        terceraCategoria: categoriasSeleccionadas[2]?.id || "-",
        marcaSelec: "-",
        modo: '-',
        palabraBuscar: '-',
        orden: selectedOrden.id ?? 0,
        mostrarNoDisponible,
        valorDolar: valorDolar,
      }));
      setSCategorias(categoriasSeleccionadas[0]?.subcategorias || []);
      setTCategorias(tercerasCategorias || []);
      setMarcaSeleccionada({});
      setServicioSeleccionado({});
      setListadoMarcas([]);
      setMostrarTodos(false);
      setNavegacionDesde("categorias");
    }
    
  }, [location.state.deCategorias, categoriasSeleccionadas, tercerasCategorias, selectedOrden, mostrarNoDisponible])
  
  return (
    <div className="w-full min-h-screen bg-GrisClaro flex justify-center items-center">
      <div className="w-11/12 min-h-screen border-2 border-GrisOscuro rounded-xl bg-Blanco mt-5 mb-5 flex flex-col p-5 sm:p-10">
        {/* Header */}
        <div className="mb-5">
          {getHeader()}
        </div>
  
        {/* Contenedor Principal */}
        <div className="w-full flex flex-col lg:flex-row lg:space-x-5">
          {/* Filtros */}
          <div className="w-full lg:w-1/4 h-auto border-2 border-GrisOscuro rounded-xl bg-GrisClaro p-3 mb-5 lg:mb-0 flex flex-col space-y-3">
            {/* Mostrar No Disponibles y Rango de Precios */}
            <div>
              {!idServicio && (
                <>
                  <IncluirNoDispobibles
                    mostrarNoDisponible={mostrarNoDisponible}
                    setMostrarNoDisponible={setMostrarNoDisponible}
                    setFiltros={setFiltros}
                    donde="mostratodo"
                  />
                  <RangoPrecios
                    setFiltros={setFiltros}
                    donde="mostratodo"
                  />
                </>
              )}
            </div>
  
            {/* Lista de Categorías/Marcas */}
            <div className="mt-5">
              <ul className="text-left w-full flex flex-col space-y-2">
                {(() => {
                  switch (true) {
                    case filtros.subCategoria !== '-' && filtros.terceraCategoria === '-' && tCategorias?.length > 0:
                      return tCategorias.map(tc => (
                        <li key={tc.id} className="text-xs lg:text-sm text-Rojo font-bold w-full">
                          <button
                            onClick={() => handleCategoria(tc, 2)}
                            className="w-full text-left flex justify-start"
                          >
                            {`> ${tc.nombre}`}
                          </button>
                        </li>
                      ));
  
                    case filtros.subCategoria === '-' && sCategorias?.length > 0:
                      return sCategorias.map(sc => (
                        <li key={sc.id} className="text-xs lg:text-sm text-Rojo font-bold w-full">
                          <button
                            onClick={() => handleCategoria(sc, 1)}
                            className="w-full text-left flex justify-start"
                          >
                            {`> ${sc.nombre}`}
                          </button>
                        </li>
                      ));
  
                    case filtros.subCategoria === '-' && categoriaServicios?.length > 0:
                      return categoriaServicios.map(cservicio => (
                        <li key={cservicio.id} className="text-xs lg:text-sm text-Rojo font-bold w-full">
                          <button
                            onClick={() => handleServicio(cservicio)}
                            className="w-full text-left flex justify-start"
                          >
                            {`> ${cservicio.titulo}`}
                          </button>
                        </li>
                      ));
  
                    case filtros.modo === 'search' || navegacionDesde === 'busqueda':
                      return (
                        <li className="text-xs lg:text-sm text-Rojo font-bold w-full">
                          <button
                            onClick={handleMostrarTodos}
                            className="w-full text-left flex justify-start"
                          >
                            {`> Mostrar todos los productos`}
                          </button>
                        </li>
                      );
  
                    default:
                      return null;
                  }
                })()}
                {listadoMarcas?.length > 0 &&
                  listadoMarcas.map(m => (
                    <li key={m.id} className="text-xs lg:text-sm text-Rojo font-bold w-full">
                      <button
                        onClick={() => handleCambioMarca(m)}
                        className="w-full text-left flex justify-start"
                      >
                        {`> ${m.nombre}`}
                      </button>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
  
          {/* Paginated Items */}
          <div className="w-full lg:w-3/4">
            {navegacionDesde === "servicios" ? (
              <PaginatedItems
                currentPage={paginaActual}
                onPageChange={cambiarPagina}
                itemsPS={serviciosFiltrados}
                itemsPerPage={10}
                type="servicios"
                totalItems={totalServiciosFiltrados}
              />
            ) : (
              <PaginatedItems
                currentPage={paginaActual}
                onPageChange={cambiarPagina}
                itemsPS={productosFiltrados}
                itemsPerPage={itemsPorPagina}
                type="productos"
                totalItems={totalProductosFiltrados}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}  

export default ProductosServicios;
